export function defaultCardConnectSettings(): RestaurantPaymentCardConnect {
  return {
    enabled: false,
    label: "",
    services: [],
    currency: "",
    site: "",
    port: "",
    merchid: "",
    username: "",
    password: "",
  };
}
